import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const ContainerStyled = styled.div`
  margin: ${props => props.theme.container.wider.margin};
  width: ${props => props.theme.container.wider.width};
  ${media.wide`
    margin: ${props => props.theme.container.wide.margin};
    width: ${props => props.theme.container.wide.width};
  `}
  ${media.small`
    margin: ${props => props.theme.container.phone.margin};
    width: ${props => props.theme.container.phone.width};
  `}
`;



// WEBPACK FOOTER //
// ./styles/components/container.style.js